import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { saveByteArray } from "src/util/saveByteArray";

enum administratorServiceEnum {
  approve = "/approval",
  reject = "/reject",
  correctPendency = "/correct-pendency",
  getRejecteds = "/rejecteds",
  getPendencies = "/pendencies",
  getPendencyDetail = "/pendency/",
  getAdminApprovalDetail = "/",
  savePendencies = "/pendencies-save",
  download = "/download"
}

export default class AdministratorApprovalService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/administrator-approval");
  }

  public tradeTransfered = async data => await this.PUT(administratorServiceEnum.approve, data);
  public tradeRejected = async data => await this.PUT(administratorServiceEnum.reject, data);
  public tradeCorrectPendency = async data => await this.PUT(administratorServiceEnum.correctPendency, data);
  public getRejecteds = async () => await this.GET(administratorServiceEnum.getRejecteds);
  public getPendencies = async () => await this.GET(administratorServiceEnum.getPendencies);
  public getPendencyDetail = async (id) => await this.GET(administratorServiceEnum.getPendencyDetail + id);
  public getAdminApprovalDetail = async (id) => await this.GET(administratorServiceEnum.getAdminApprovalDetail + id);
  public savePendencies = async data => await this.POST(administratorServiceEnum.savePendencies, data);

  public download = async (id, fileName) => {
    const endpoint = administratorServiceEnum.download + "?id=" + id;
    const data = await this.GET(endpoint, "blob");
    saveByteArray(fileName, data);
    return data;
  };
}


// WEBPACK FOOTER //
// ./src/services/api/AdministratorApproval.service.ts